import ProfilePicture from 'components/elements/ProfilePicture'
import Row from 'components/elements/Row'
import Stack from 'components/elements/Stack'
import { KnowComment } from 'interfaces/KnowComment'
import { formatDate } from 'lib/formatting/datetime'
import _useTranslation from 'lib/hooks/_useTranslation'
import { useState } from 'react'
import { ApiError } from 'services/ApiService'
import KnowService from 'services/KnowService'
import { Body2, ButtonText, CustomizableInlineText } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import Arrow from 'assets/icons/select-arrow.svg'
import styled from 'styled-components'

const ArrowIcon = styled(Arrow)`
    path {
        fill: ${theme.colors.knowunityBlue};
    }
`

interface Props {
    comment: KnowComment
    isDarkTheme?: boolean
}

const KnowSubComments = ({ comment, isDarkTheme }: Props) => {
    const [commentResponses, setCommentsResponses] = useState<KnowComment[]>()
    const { t: tCommon } = _useTranslation('common')
    const { t } = _useTranslation('knows')

    if (!comment.commentResponseCount) return null

    const fetchCommentResponses = () => {
        KnowService.getKnowCommentsResponses(comment.uuid)
            .then((commentResponses) => {
                setCommentsResponses(commentResponses)
            })
            .catch((error) => {
                if (error instanceof ApiError) {
                    error.handleUnknownError(tCommon, 'know.getKnowCommentsResponses')
                } else {
                    throw error
                }
            })
    }

    return (
        <Stack>
            {commentResponses?.length ? (
                <>
                    {commentResponses.map((commentResponse) => (
                        <div key={commentResponse.uuid} className="desktop-comment">
                            <ProfilePicture user={commentResponse.user} />
                            <Stack gutter={5}>
                                <ButtonText
                                    fontFamily="var(--font-inter)"
                                    fontWeight={700}
                                    color={isDarkTheme ? theme.colors.white : theme.colors.headlineDark}
                                >
                                    {commentResponse.user.username}
                                    {'⠀'}
                                    <CustomizableInlineText
                                        fontWeight={300}
                                        hideCursor
                                        color={isDarkTheme ? theme.colors.white : theme.colors.actionGray}
                                    >
                                        {formatDate(commentResponse.createdOn)}
                                    </CustomizableInlineText>
                                </ButtonText>
                                <Body2
                                    fontFamily="var(--font-inter)"
                                    fontWeight={400}
                                    color={isDarkTheme ? theme.colors.grayScaleSecondary : theme.colors.subtitleBlack}
                                >
                                    {commentResponse.content}
                                </Body2>
                            </Stack>
                        </div>
                    ))}
                </>
            ) : (
                <Row onClick={fetchCommentResponses} gap={10} style={{ cursor: 'pointer' }}>
                    <ArrowIcon />
                    <ButtonText fontFamily="var(--font-inter)" fontWeight={500} color={theme.colors.knowunityBlue}>
                        {`${t('knows/knowDetailsComments')} ${comment.commentResponseCount}`}
                    </ButtonText>
                </Row>
            )}
        </Stack>
    )
}

export default KnowSubComments
